import { useNotifications } from '@sequencehq/core-components'
import { useMutation } from '@sequencehq/api/utils'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { logError } from '@sequencehq/utils'
import { getApiErrorMessage } from 'Cube/utils/getApiErrorMessage'

export const useUpdateAnrokMapping = () => {
  const { displayNotification } = useNotifications()

  const { mutateAsync: putTaxCategoryAnrokMapping } = useMutation(
    dashboardv99990101Client.putTaxCategoryAnrokMapping
  )

  return async ({
    taxCategoryId,
    taxCategoryName,
    anrokTaxCategoryId,
    anrokTaxCategoryType,
    isDefault
  }: {
    taxCategoryId: string
    taxCategoryName: string
    anrokTaxCategoryId: string
    anrokTaxCategoryType: 'standard' | 'custom'
    isDefault: boolean
  }) => {
    try {
      await putTaxCategoryAnrokMapping({
        taxCategoryId,
        body: {
          taxCategoryName,
          anrokTaxCategoryId,
          anrokTaxCategoryType,
          isDefault
        }
      })

      displayNotification('Anrok tax code mapping updated', {
        type: 'success'
      })
    } catch (error) {
      console.error('Failed to update Anrok mapping:', error)
      logError(error)

      const backendMessage = getApiErrorMessage(error, '')
      const errorMessage = backendMessage
        ? `Failed to update Anrok tax code mapping: ${backendMessage}`
        : 'Failed to update Anrok tax code mapping'

      displayNotification(errorMessage, {
        type: 'error'
      })
      throw error
    }
  }
}
